// pages/Construction.jsx
import { Box, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

const Construction = () => {
  const navigate = useNavigate();

  return (
    <Box
      minHeight="80vh"
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      textAlign="center"
    >
      <Typography variant="h4" fontWeight={700}>
        Page Under Construction
      </Typography>

      <Typography sx={{ mt: 2, opacity: 0.8 }}>
        This section is currently being built.
      </Typography>

      <Button sx={{ mt: 3 }} variant="outlined" onClick={() => navigate("/")}>
        Go Back Home
      </Button>
    </Box>
  );
};

export default Construction;
